import { PIXEL_API_LIST, GOOGLE_PIXEL_EVENTS, ENTER_YOUR_OWN_EVENT } from '/src/features/goals/constants';

export function getPixelEventOptions(api) {
  return [
    { value: '', label: 'Any' },
    ...(api === PIXEL_API_LIST.GOOGLE ? GOOGLE_PIXEL_EVENTS : []),
    { value: ENTER_YOUR_OWN_EVENT },
  ];
}
